import { Percentage } from '@sparkdotfi/common-universal'

import { formatPercentage } from '@/domain/common/format'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { getTokenColor } from '@/ui/assets'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/ui/atoms/tooltip/Tooltip'

export interface SparkRewardPillProps {
  rewardTokenSymbol: TokenSymbol
  rewardTokenLogo: string
  longDescription: string
  apy?: Percentage
}

export function SparkRewardPill({ rewardTokenSymbol, rewardTokenLogo, longDescription, apy }: SparkRewardPillProps) {
  const tokenColor = getTokenColor(rewardTokenSymbol)

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          className="flex h-5 items-center justify-center gap-1.5 rounded-xxs border px-1 outline-hidden"
          style={{ borderColor: tokenColor }}
        >
          <img src={rewardTokenLogo} alt={rewardTokenSymbol} className="size-3" />
          {apy?.gt(0) && (
            <div className="typography-button-2" style={{ color: tokenColor }}>
              {formatPercentage(apy, { minimumFractionDigits: 1 })}
            </div>
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent>{longDescription}</TooltipContent>
    </Tooltip>
  )
}

export interface SparkRewardCampaign extends SparkRewardPillProps {
  campaignId: string
}
